"use strict";
export const PaymentCoinsMock = (mock) => {
  mock.onGet("/api/v7/coins").reply((config) => {
    let response = {
      model: "account_coins.get_account_coins",
      operation: "SUCCESS",
      account_coins: {
        model: "account_coins",
        coins: 991.6
      }
    };
    return [200, response];
  });
};
